var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"countContainer"},[_c('button',{staticClass:"btn",attrs:{"disabled":_vm.disabled || _vm.time > 0}},[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }